<template>
    {{ insert.sorting }}:
    <my-select
        class="ml-4"
        :options="sortOptions"
        :insert="insert.mySelect"
        @updateSelect="updateSelect"
    />

    <hr class="hr-dashed mb-30">

    <div v-if="$store.state.isProdsLoading" class="loader1 mb-14"></div>
    <div v-else>
        <div v-if="$store.getters.products">
            <div class="row row-cols-xs-1 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 row-cols-xl-6">
                <div v-for="prod in $store.state.products"
                    :key="prod.id"
                    class="col mb-20"
                    @click.stop="selectProduct( prod.id, prod.price, prod.pictures, prod.brand, prod.model )"
                    >
                    <div class="card4 ">
                        <Prod-Items
                            :prod="prod"
                            :insert="insert.prodItems"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="mb-30">{{ insert.notFound }}</div>
    </div>

    <hr class="hr-dashed mt-30">

    <div class="page__wrapper mb-30" v-if="!$store.state.isProdsLoading">
        <div
            v-for="pageNumber in $store.state.totalPages"
            :key="pageNumber"
            @click="changePage(pageNumber)"
            class="page"
            :class="{ 'current-page': $store.state.page === pageNumber }"
            >
            {{ pageNumber }}
        </div>
    </div>
</template>

<script>
import useAuth from '@/hooks/useAuth'
import useNotify from '@/hooks/useNotify'
import useProducts from '@/hooks/useProducts'
import ProdItems from './ProdItems.vue'
import MySelect from '@/components/UI/MySelect.vue'
import { define } from '@/data/globals.js'

export default {
    components: {
        ProdItems,
        MySelect,
    },
    props: {
        insert: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            idToDelete: 0,
            sortOptions: [
                {value: 'brand', name: this.insert.byBrand},
                {value: 'model', name: this.insert.byModel},
                {value: 'price', name: this.insert.byPrice},
            ],
        }
    }, // data
    methods: {
        selectProduct(id, price, pictures, brand, model) {
            // console.log('selectProduct id:' + id);

            this.$store.commit('SetUpdProd', [ id, price, pictures, brand, model ])
            this.$store.commit('SetUpdProdTranslation', [ '', '' ])

            this.$router.push('/cars/' + id )
        },

        changePage(pageNumber) {
            this.$store.commit('SetPage', pageNumber)
            this.getProducts()
        },

        updateSelect(value) {
            this.$store.commit('SetSortSelected', value)
            this.getProducts()
        },
    },// methods

    watch: {
        'insert.sorting': {
            handler() {
            // handler(val) {
                // console.log('val: ', val)
                this.sortOptions = [
                    {value: 'brand', name: this.insert.byBrand},
                    {value: 'model', name: this.insert.byModel},
                    {value: 'price', name: this.insert.byPrice},
                ]
            },
            // deep: true,
        },
    },

    setup() {
        const { tokenRefresh } = useAuth()
        const { pushNotify } = useNotify()
        const { page, limit, getProducts } = useProducts()

        return { define, tokenRefresh, pushNotify, page, limit, getProducts }
    }
}
</script>

<style>

.row > * {
    padding-right: 0 !important;
    padding-left: 0 !important;
}

.card4{
    height: 100%;

    border-radius: 14px;
    border: 3px solid #FFFFFF;
    box-shadow: 0px 0px 14px #00000034;
    background: #FFFFFF;
    margin-left: 4px;
    margin-right: 4px;
    margin-bottom: 15px;
    padding-top: 10px;
    padding-left: 8px;
    padding-right: 8px;

    font-size: 1.1rem;
    line-height: 1.3rem;
    transition-duration: 0.3s;
}

.card4:hover{
    border: 3px solid #00b809;
    box-shadow: 0px 0px 20px #00000044;
    transition-duration: 0.1s; 
    cursor: pointer;
}

.card4 img{
    display: block;
    max-width: 100%;
    height: auto;
    margin-bottom: 10px;
    border-radius: 5px;
}



.page__wrapper {
  display: flex;
  margin-top: 15px;
}

.page {
  border: 1px solid #0000005d;
  border-radius: 8px;
  padding: 10px 16px;
  margin-right: 6px;
  cursor: pointer;
}

.current-page {
  border: 1px solid #00b809;
  box-shadow: 0 0 1px 1px #00b809;
}

</style>